import { useEffect, useState } from "react"
import { MojeTextInput } from "./MojeTextInput"
import React from "react"

export const PriceCentsInput = React.forwardRef<any, any>(
  ({ value, onChange, ...props }, ref) => {
    const [textValue, setTextValue] = useState(
      value ? (value / 100).toString() : ""
    )

    useEffect(() => {
      try {
        var num = Number(textValue)
        const cents = num * 100
        onChange({ target: { value: num * 100 } })
      } catch (err) {
      }
    }, [textValue])
    return (
      <MojeTextInput
        inputRef={ref}
        {...props}
        value={textValue}
        onChange={(e) => {
          setTextValue(e.target.value)
        }}
      />
    )
  }
)
